import { render, staticRenderFns } from "./DetailStoreGiftListComponent.vue?vue&type=template&id=58af8c10&scoped=true"
import script from "./DetailStoreGiftListComponent.vue?vue&type=script&lang=js"
export * from "./DetailStoreGiftListComponent.vue?vue&type=script&lang=js"
import style0 from "./DetailStoreGiftListComponent.vue?vue&type=style&index=0&id=58af8c10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58af8c10",
  null
  
)

export default component.exports